import localhost from "apis/localhost";

import {
  setCustomers,
  setCustomersLoaded,
  setCustomersLoading,
} from "./customerSlice";

export const fetchCustomers = () => async (dispatch, getState) => {
  const { customersLoaded, customersLoading } =
    getState().opportunity.customers;

  // Prevent duplicate fetches
  if (customersLoaded || customersLoading) {
    return;
  }

  dispatch(setCustomersLoading(true));
  try {
    const rsp = await localhost.get("/nextgen/customers/with-agencies");
    const data = rsp?.data || [];
    dispatch(setCustomers(data));
    dispatch(setCustomersLoaded(true));
  } catch (err) {
    console.error("Failed to fetch customers:", err);
    dispatch(setCustomers([]));
  } finally {
    dispatch(setCustomersLoading(false));
  }
};
